import React, {
  useState, useRef, useCallback, useEffect,
} from 'react'
import { useRouter } from 'next/router'

import SectionContainer from '@/Section/Container'
import { normalizedContentData } from 'services/models/NewsItemsArchive'

import Filters from '@/Filters'
import NewsPreview from '@/Previews/NewsPreview'
import Tab from '@/UI/Tabs/Tab'
import {
  StyledTabsHeader,
} from '@/UI/Tabs/styles'

const HEADER_OFFSET = 20
const SCROLL_KEY = 'newsScrollToTabs'

const scrollToElement = (element) => {
  if (!element) return
  const header = document.querySelector('header')
  const headerHeight = header?.offsetHeight || 0
  const top = element.getBoundingClientRect().top + window.scrollY
  window.scrollTo({
    top: top - headerHeight - HEADER_OFFSET,
    behavior: 'smooth',
  })
}

const NewsItemsArchive = ({
  sectionGeneral: {
    theme,
  },
  sectionHeader,
  sectionContent,
}) => {
  const router = useRouter()
  const { categoryTabs, ...filterProps } = sectionContent
  const tabsRef = useRef(null)
  const [isNavigating, setIsNavigating] = useState(false)

  const activeTabId = categoryTabs?.currentSlug || 'all'

  // Scroll alle tabs dopo navigazione tra categorie
  useEffect(() => {
    const shouldScroll = sessionStorage.getItem(SCROLL_KEY)
    if (!shouldScroll || !tabsRef.current) return

    sessionStorage.removeItem(SCROLL_KEY)

    const timer = setTimeout(() => {
      scrollToElement(tabsRef.current)
    }, 150)

    return () => clearTimeout(timer)
  }, [activeTabId])

  const handleCategoryClick = useCallback((tabId) => {
    if (tabId === activeTabId) return

    setIsNavigating(true)
    sessionStorage.setItem(SCROLL_KEY, '1')

    let href
    if (tabId === 'all') {
      href = categoryTabs.parentHref || '/'
    } else {
      const category = categoryTabs.items.find((c) => c.id === tabId)
      href = category?.href
    }

    if (href) {
      router.push(href, undefined, { scroll: false })
    }
  }, [activeTabId, categoryTabs, router])

  return (
    <SectionContainer
      theme={theme}
      sectionHeader={sectionHeader}
      headerCta={sectionContent.headerCta}
    >
      {categoryTabs && (
        <div ref={tabsRef} style={{
          marginBottom: 24,
          opacity: isNavigating ? 0.5 : 1,
          transition: 'opacity 0.3s ease',
          pointerEvents: isNavigating ? 'none' : 'auto',
        }}>
          <StyledTabsHeader
            data-lenis-prevent
            withDropDown={false}
          >
            <Tab
              id="all"
              theme="noBackground"
              onTabClick={handleCategoryClick}
              selectedTab={activeTabId}
              title={categoryTabs.allLabel}
              size="big"

            />
            {categoryTabs.items.map((category) => (
              <Tab
                key={category.id}
                id={category.id}
                theme="noBackground"
                onTabClick={handleCategoryClick}
                selectedTab={activeTabId}
                title={category.title}
                size="big"
              />
            ))}
          </StyledTabsHeader>
        </div>
      )}
      <Filters
        {...filterProps}
        ElementToRender={NewsPreview}
        normalizeFunction={normalizedContentData}
        overlap={false}
      />
    </SectionContainer>
  )
}

export default NewsItemsArchive
